import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import LinkCell from "./LinkCell"
import Utils from "../../utils/Utils";

export default class LinkReel { 
    protected scene: any;

    public gameDataManager: any;
    public gameLogicVariableManager: any;

    protected index: number = 0;

    private container: Phaser.GameObjects.Container;
    private frameContainer: Phaser.GameObjects.Container;
    private animationsContainer: Phaser.GameObjects.Container;

    public frame: Phaser.GameObjects.Image;

    protected spinProgress!: Phaser.Tweens.Tween;
    protected bounceTween1: Phaser.Tweens.Tween | undefined;
    protected bounceTween2: Phaser.Tweens.Tween | undefined;

    protected spinProgressValue: { value: number; } = { value: 0 };
    public readonly spinAnimationDuration: number = 300;

    public readonly suspenseDuration: number = 600;
    protected virtualReelPosition: number = 0;
    protected realMemoIndex: number = 0;

    public canStop: boolean | undefined;
    public stopped: boolean | undefined;

    public stopEvent: Phaser.Time.TimerEvent | undefined;

    public linkReelMask!: Phaser.GameObjects.Graphics;
    public lastMaskX: any;
    public lastMaskY: any;
    public lastMaskWidth: any;
    public lastMaskHeight: any;

    /** Cells of the reel */
    public linkCells: LinkCell[] = [];
    public fixedLinkCell: LinkCell;

    public numOfLinkCellsPerReel: any;
    public numOfExtraLinkCellsPerReel : any;
    public linkCellsPosition : any;
    public lastLinkCellIndex : any;
    public cellSize: any;
    public linkReelsPosition : any

    public spinSpeed: number; //TODO Renderlo costante che arriva dal gioco
    protected t0: number = 0;
    public preStopMs = 2200;    // tempo “attivo” prima del bounce (fisso!)

    public startDelayMs: number;
    public phaseOffsetPx: number;
    protected spinMainButtonTween: Phaser.Tweens.Tween = null as any;
    protected isButtonSpinning: boolean = false;

    public readonly baseSpeed = 1.9;                     // velocità base
    public readonly speedJitter = 0.08;                  // piccola variazione
    public readonly delayPerReel = 120;                  // ms di ritardo per indice
    public readonly extraDelayJitter = 50;               // jitter per non farli allineare

    constructor(scene: any, x: number, y: number, index: number, gameLogicVariableManager: any, gameDataManager: any, orientation: any) {
        this.scene = scene;
        this.gameLogicVariableManager = gameLogicVariableManager;
        this.gameDataManager = gameDataManager;
        
        this.index = index;
                
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.numOfLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL;
        this.numOfExtraLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_LINK_CELLS_PER_REEL;
        this.linkCellsPosition = ResourcesDispatcher.GAME_CONSTANTS.linkCellsPosition;
        this.linkReelsPosition = ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition;
        this.lastLinkCellIndex = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL + this.numOfExtraLinkCellsPerReel - 1;
        
        this.container = this.scene.add.container(x, y);
        this.createReelMask(orientation);

        this.startDelayMs = index * this.delayPerReel + Phaser.Math.Between(0, this.extraDelayJitter);
        this.spinSpeed   = this.baseSpeed + index * 0.12 + Phaser.Math.FloatBetween(-this.speedJitter, this.speedJitter);
        this.phaseOffsetPx = Math.round((index * (this.cellSize.height /  ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS)) % this.cellSize.height);

        this.fixedLinkCell = new LinkCell(this.scene, this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, 1);
        this.animationsContainer = this.scene.add.container(x, y);
        this.animationsContainer.add(this.fixedLinkCell.getContainer());
        this.fixedLinkCell.getContainer().setVisible(false);

        this.frame = this.scene.add.image(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, ResourcesDispatcher.ATLAS.LINKREEL_FRAME.key, ResourcesDispatcher.ATLAS.LINKREEL_FRAME.frameKey).setOrigin(0.5, 0.5);
        this.frameContainer = this.scene.add.container(x, y);
        this.frameContainer.add(this.frame);
    }

    public createReelMask(orientation: any): void {
        return
        // se esiste già una graphics/mask precedente la distruggiamo e rimuoviamo la mask dal container
        if (this.linkReelMask) {
            this.linkReelMask.destroy();
            this.container.clearMask(true);
            this.linkReelMask = undefined as any;
        }

        const visibleHeight = this.cellSize.height * this.numOfLinkCellsPerReel;
        const isPortrait = orientation;

        let xContainer = 0;
        let yContainer = 0;
        let scale = 0;

        if(isPortrait == "portrait") {
            xContainer = this.container.x + 155;
            yContainer = this.container.y + 796;
            scale = 0.85;
        }
        else{
            xContainer = this.container.x + 525;
            yContainer = this.container.y + 280;
            scale = 1;
        }

        // crea la graphics che useremo per la mask (la aggiungiamo alla scena per poterla gestire/distruggere facilmente)
        this.linkReelMask = this.scene.make.graphics({ x: 0, y: 0, add: false});
        this.linkReelMask.fillRect(xContainer, yContainer, this.cellSize.width, visibleHeight).setScale(scale);

        // Serve per mostrare la maschera della griglia per debuggare
        // const debugGraphics = this.scene.add.graphics();
        // debugGraphics.lineStyle(2, 0x000000, 1); // spessore 2px, bianco

        // this.linkCells.forEach((cell) => {
        //     const c = cell.getContainer(); // container grafico della cella
        //     const width = this.cellSize.width;
        //     const height = visibleHeight;

        //     debugGraphics.strokeRect(xContainer, yContainer, width, height).setScale(scale);
        // });

        // assegna la GeometryMask basata sulla graphics appena creata
        this.container.setMask(new Phaser.Display.Masks.GeometryMask(this.scene, this.linkReelMask));
    }

    public setIndex(value: number) {
        this.index = value;
    }

    public getIndex(): number {
        return this.index;
    }

    public getContainer(): Phaser.GameObjects.Container {
      return this.container;
    }

    public getFrameContainer(): Phaser.GameObjects.Container {
        return this.frameContainer;
    }

    public getAnimationsContainer(): Phaser.GameObjects.Container {
        return this.animationsContainer;
    }

    public resetFlagsAndCounters(): void {
        this.virtualReelPosition = Utils.getRandomInt(0, this.scene.linkGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.canStop = false;
        this.stopped = false;
        this.realMemoIndex = 0;

        this.removeStopEvent();
    }

    public removeStopEvent(): void {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }

        this.stopEvent = undefined;
    }

    public resetCellsPositions(): void {
        this.linkCells.forEach((linkCell, index) => {
            linkCell.getContainer().y = this.linkCellsPosition[index].y;
        });
    }

    public reIndexCells(): void {
        let linkCells: LinkCell[] = [];

        for (let i = 1; i < this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel; i++) {
            linkCells[i - 1] = this.linkCells[i];
            this.linkCells[i].setIndex(i - 1);
        }

        this.linkCells[0].setIndex(this.lastLinkCellIndex);
        linkCells[this.lastLinkCellIndex] = this.linkCells[0];

        this.linkCells = [];
        this.linkCells = linkCells;
    }
        

    public get stepMs() { return this.spinAnimationDuration / this.spinSpeed; }

    public configureSpinTween(): void {
        this.resetFlagsAndCounters();
    }

    //Chiamato dal gioco per far partire il giro del rullo
    public spin(mainButtonBackground?: any) {
        this.spinProgress.play();  
        
        if(mainButtonBackground){
            if ((window as any).isButtonSpinning === false) {
                (window as any).isButtonSpinning = true;
                
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground, this.scene);
            }
        }
    }
    
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    public securityCheckStop(): void {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        } else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        } else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }

    public reset(): void {
        this.fixedLinkCell.getContainer().setVisible(false).setAlpha(1);
        this.fixedLinkCell.setMemo(0);
        this.fixedLinkCell.multValue = -1;

        this.container.setVisible(true);

        this.fixedLinkCell.getLinkSpineValueText().setVisible(false);
        this.fixedLinkCell.getLinkSpineWithValue().setVisible(false);
        this.fixedLinkCell.getLinkSpineWithText().setVisible(false).setAlpha(1);
    }

    public updateMask(_x: number, _y: number): void {
        return
        const x: number = _x + (this.linkReelsPosition[this.getIndex()].x);
        const y: number = _y + (this.linkReelsPosition[this.getIndex()].y);
        const width: number = this.cellSize.width;
        const height: number = this.cellSize.height;

        if (this.lastMaskX === x && this.lastMaskY === y && this.lastMaskWidth === width && this.lastMaskHeight === height) {
            return;
        }

        // destroy the previous mask and create the new one
        if (this.linkReelMask) {
            this.linkReelMask.destroy();
        }

        this.container.clearMask(true);

        if (this.scene.linkGameArea.drawMask) {
            this.linkReelMask = this.scene.add.graphics({});
            this.linkReelMask.fillStyle(0xffffff, 0);
            this.linkReelMask.fillRect(x, y, width, height);
            this.container.setMask(new Phaser.Display.Masks.GeometryMask(this.scene, this.linkReelMask)); //SBAGLIATA

            this.lastMaskX = x;
            this.lastMaskY = y;
            this.lastMaskWidth = width;
            this.lastMaskHeight = height;
        }
    }
}
